<template>
  <div>
    <success :success="success"/>

    <form @submit.prevent="reset" v-if="!success">

      <login-card header-color="green">
        <h4 slot="title" class="card-title">Востановление пароля</h4>

        <error slot="description" :errors="errors"/>

        <md-field class="md-form-group" slot="inputs" v-for="(input, key) in auth" :key="key">
          <md-icon>{{ input.icon }}</md-icon>
          <label>{{ input.label }}</label>
          <md-input v-model="input.value" :type="input.type"></md-input>
        </md-field>

        <md-button slot="footer" class="md-simple md-success md-lg" type="submit">
          Ок
        </md-button>

      </login-card>
    </form>
  </div>
</template>

<script>
import Error from "./Error"
import {mapActions} from "vuex"
import { LoginCard } from "@/components"
import Success from "./Success";

export default {
  name: "ResetPassword",
  components: {Success, Error, LoginCard},
  props: ['token'],
  data(){
    return {
      auth: {
        email: {
          label: 'Ваш email адресс',
          value: '',
          type: 'email',
          icon: 'alternate_email',
        },
        password: {
          label: 'Ваш пароль',
          value: '',
          type: 'password',
          icon: 'password',
        },
        password_confirmation: {
          label: 'Повторите пароль',
          value: '',
          type: 'password',
          icon: 'password',
        }
      },
      is_admin : null,
      errors: null,
      success: null
    }
  },
  methods: {
    ...mapActions(["auth/reset_password"]),
    reset: function () {
      let data = {
        token: this.token,
        email: this.auth.email.value,
        password: this.auth.password.value,
        password_confirmation: this.auth.password_confirmation.value
      }
      this.$store.dispatch('auth/reset_password', data)
          .then((response) => {
            this.errors = [];
            this.success = response;
          })
          .catch(err => {
            this.errors = [];
            if(err.message === 'The given data was invalid.') {
              for (let i in err.errors) {
                for (let j in err.errors[i]) {
                  this.errors.push(err.errors[i][j]);
                }
              }
            } else this.errors = err
          })
    }
  }
}
</script>